// Copyright (c) 2017 Deere & Company

const pipCodeRequestFilterOptions = [
    ['pin'],
    ['dealer', 'name'],
    ['dealer', 'location', 'city'],
    ['dealer', 'location', 'state'],
    ['dealer', 'account'],
    ['pipCodeType', 'value'],
    ['pipNumber'],
    ['createDate']
];

export default pipCodeRequestFilterOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/pip-code-request-filter-options.js